import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { PageSettings } from '../../config/page-settings.js';
import { loadCaptchaEnginge, LoadCanvasTemplate, validateCaptcha } from 'react-simple-captcha';
import withNotification from '../../components/HOCNotification/HOCNotification.component';
import Auth from '../../services/auth';
import { RESPONSE, COPYRIGHT } from '../../config/constants';
import Services from '../../services/service';
import './login.css';

const auth = new Auth();
const { SUCCESS, FAILED, INVALID } = RESPONSE;

class Login extends React.Component {
  static contextType = PageSettings;

  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      captchaVerify: '',
      formErrors: [],
      submitLoading: false,
      passwordShown: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.togglePasswordShown = this.togglePasswordShown.bind(this);
  }

  componentDidMount() {
    this.context.handleSetPageSidebar(false);
    this.context.handleSetPageHeader(false);
    this.context.handleSetBodyWhiteBg(true);
    loadCaptchaEnginge(5, '#348fe2', 'white');
  }

  componentWillUnmount() {
    this.context.handleSetPageSidebar(true);
    this.context.handleSetPageHeader(true);
    this.context.handleSetBodyWhiteBg(false);
  }

  renderCaptcha(){
    return (
      <LoadCanvasTemplate reloadColor="#348fe2" />
    )
  }

  handleChange = (e) => {
    const {name, value} = e.target;
    const state = { [name]: value };
    this.setState(state);
  };

  handleSubmit(e) {
    e.preventDefault();
    const validate = this.validateForm();
    if (validate) {
      this.postLogin();
    }
  }

  validateForm() {
    let errors = [];
    if (this.state.username === '') {
      errors.push('username');
    }
    if (this.state.password === '') {
      errors.push('password');
    }
    if (this.state.captchaVerify === '') {
      errors.push('captchaVerify');
    }

    this.setState({
      formErrors: errors,
    });

    if (errors.length > 0) {
      return false;
    } else {
      return true;
    }
  }

  hasError(key) {
    return this.state.formErrors.indexOf(key) !== -1;
  }

  postLogin = async () => {
    const { username, password, captchaVerify } = this.state;
    const payload = { username, password };

    if (!validateCaptcha(captchaVerify)) {
      this.props.toggleNotification(INVALID, 'Captcha tidak sesuai');
      this.setState({captchaVerify: ''});
      return;
    }

    this.setState({ submitLoading: true });

    Services.postLogin(payload)
      .then(async (res) => {
        if (res) {
          this.props.toggleNotification(SUCCESS, 'Login Berhasil');
          auth.setSession(res);
        }
      })
      .catch((err) => {
        this.setState({ submitLoading: false });
        const parseErr = err.request?.response
          ? JSON.parse(err.request.response)
          : { error: 'Login tidak berhasil. Silahkan kontak admin.' };
        this.props.toggleNotification(FAILED, parseErr.error);
      });
  };

  togglePasswordShown() {
    this.setState({ passwordShown: !this.state.passwordShown });
  }

  render() {
    const { username, password, captchaVerify, submitLoading, passwordShown } =
      this.state;
    return (
      <div className="login login-with-news-feed">
        <div className="news-feed">
          <div
            className="news-image"
            style={{
              backgroundImage: 'url(/assets/img/login-bg/login-image.jpg)',
            }}
          ></div>
          <div className="news-caption">
            {/* <img className="img-responsive" style={{maxWidth: '290px'}} src={'/assets/img/logo/logo-white.png'} alt="Logo KPSS"></img> */}
          </div>
        </div>
        <div className="right-content">
          <div className="login-header">
            <div className="brand">
              <img
                className="img-responsive"
                src={'/assets/img/logo/logo-color.png'}
                alt="Logo KPSS"
              ></img>
            </div>
            <div className="icon">
              <i className="fa fa-sign-in"></i>
            </div>
          </div>
          <div className="login-content">
            <form className="margin-bottom-0">
              <div className="form-group m-b-15">
                <input
                  type="text"
                  className={`form-control form-control-lg ${
                    this.hasError('username') ? 'is-invalid' : ''
                  }`}
                  placeholder="Username"
                  name="username"
                  onChange={this.handleChange}
                  value={username}
                />
                <div className="invalid-feedback">Username wajib diisi.</div>
              </div>
              <div className="form-group pass-wrapper m-b-20">
                <input
                  type={passwordShown ? 'text' : 'password'}
                  className={`form-control form-control-lg ${
                    this.hasError('password') ? 'is-invalid' : ''
                  }`}
                  placeholder="Password"
                  name="password"
                  onChange={this.handleChange}
                  value={password}
                />
                <i
                  className={passwordShown ? 'fa fa-eye' : 'fa fa-eye-slash'}
                  onClick={this.togglePasswordShown}
                ></i>
                <div className="invalid-feedback">Password wajib diisi.</div>
              </div>
              <div className="row form-group m-b-30 text-center">
                <div className="col-lg-7 col-md-6 col-sm-7 col-xs-6">
                  <input
                    type="text"
                    className={`form-control form-control-lg ${
                      this.hasError('captchaVerify') ? 'is-invalid' : ''
                    }`}
                    placeholder="Captcha Code"
                    name="captchaVerify"
                    onChange={this.handleChange}
                    value={captchaVerify}
                  />
                  <div className="invalid-feedback">Captcha wajib diisi.</div>
                </div>

                <div className="col-lg-5 col-md-6 col-sm-5 col-xs-6 mt-2">
                  {this.renderCaptcha()}
                </div>
              </div>
              <div className="login-buttons">
                <button
                  type="submit"
                  className="btn btn-blue btn-block btn-lg"
                  disabled={submitLoading}
                  onClick={this.handleSubmit}
                >
                  {submitLoading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    'Sign me in'
                  )}
                </button>
              </div>
            </form>
            <div className="m-t-20 m-b-40 p-b-40 text-inverse text-center">
              Lupa Password? Klik{' '}
              <Link to="/login/forgot-password" className="text-success">
                disini
              </Link>{' '}
              untuk merubah password anda.
            </div>
            <hr />
            <p className="text-center text-grey-darker">
              {COPYRIGHT}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default withNotification(withRouter(Login));
